var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-content"},[_c('div',{staticClass:"empty-content__icon"},[_c('svg-icon',{attrs:{"type":_vm.content.icon}})],1),_c('div',{staticClass:"empty-content__title"},[_vm._v(_vm._s(_vm.content.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }